module.exports = __webpack_public_path__ + "img/PcContent4.58baff62.png";